import { type CanvasPackageParseResult } from '@littlebird/canvas';

import { CanvasFrame } from '@/features/canvas';
import { SpriteFrame } from '@/features/sprites/SpriteFrame';
import { cn } from '@/lib/utils';

import { type ArtifactRenderer } from './artifact-presentation';
import { PAPER_PAGE_UNSCALED_CLASS } from './artifact.constants';
import { PdfPreviewFrame } from './PdfPreviewFrame';

const PAPER_PAGE_CLASS = cn(PAPER_PAGE_UNSCALED_CLASS, 'scale-[0.18]');

const PAPER_PDF_PAGE_CLASS = cn(
  PAPER_PAGE_CLASS,
  '-left-[2px] -top-[2px] h-[920px] w-[684px]'
);

interface ArtifactPaperContent {
  text: string;
  url: string;
  versionKey: string;
  canvasParseResult?: CanvasPackageParseResult;
}

export const renderPaperChild = (
  renderer: ArtifactRenderer,
  { text, url, versionKey, canvasParseResult }: ArtifactPaperContent,
  pageClassName: string = renderer === 'pdf'
    ? PAPER_PDF_PAGE_CLASS
    : PAPER_PAGE_CLASS
) => {
  switch (renderer) {
    case 'canvas':
      return (
        <CanvasFrame
          title=""
          canvasText={text}
          cacheKey={versionKey}
          parseResult={canvasParseResult}
          className={pageClassName}
        />
      );
    case 'html':
      return (
        <SpriteFrame
          title="Artifact preview"
          html={text}
          className={cn(pageClassName, 'bg-white')}
        />
      );
    case 'pdf':
      return (
        <PdfPreviewFrame
          title="Artifact preview"
          url={url}
          hideToolbar
          className={cn(pageClassName, 'bg-white')}
        />
      );
    case 'image':
      return (
        <img src={url} alt="" className="size-full object-cover object-top" />
      );
    default:
      return null;
  }
};
